module.exports = __webpack_public_path__ + "img/SEGURIFY_GIF_HDI.cfbca1e7.gif";